module.exports = __webpack_public_path__ + "2-57.gif?02e91a56459af3367bbcfa65f28a9419";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-57.gif
// module id = 134
// module chunks = 0